import React from 'react'
import { IconView } from './IconView'
import { useIcon } from './useIcon'

interface IIconProps {
  name: string
  color?: string | ''
  size?: number | 24
}
export type IconProps = IIconProps

export const Icon = (props: IconProps): JSX.Element => {
  return (<IconView {...useIcon(props)} />)
}
